import { Component, AfterViewInit, ViewChild, ElementRef, HostListener } from "@angular/core";
import { Router } from "@angular/router";
import { createPopper } from "@popperjs/core";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { ModalComponent } from "src/app/shared/modal/modal.component";

@Component({
  selector: "app-user-dropdown",
  templateUrl: "./user-dropdown.component.html",
})
export class UserDropdownComponent implements AfterViewInit {

  isAuthenticated: boolean = false;

  constructor(
    private oidcSecurityService: OidcSecurityService, 
    private router: Router
  ){}


  @ViewChild('modal') modal!: ModalComponent;

  dropdownPopoverShow = false;
  @ViewChild("btnDropdownRef", { static: false }) btnDropdownRef: ElementRef;
  @ViewChild("popoverDropdownRef", { static: false })
  popoverDropdownRef: ElementRef;
  ngAfterViewInit() {
    createPopper(
      this.btnDropdownRef.nativeElement,
      this.popoverDropdownRef.nativeElement,
      {
        placement: "bottom-start",
      }
    );
  }
  toggleDropdown(event) {
    event.preventDefault();
    if (this.dropdownPopoverShow) {
      this.dropdownPopoverShow = false;
    } else {
      this.dropdownPopoverShow = true;
    }
  }
  // Listen for clicks on the document
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (
      this.dropdownPopoverShow &&
      !this.btnDropdownRef.nativeElement.contains(target) &&
      !this.popoverDropdownRef.nativeElement.contains(target)
    ) {
      this.dropdownPopoverShow = false;
    }
  }

  login() {
    // this.oidcSecurityService.authorize(undefined, {
    //   customParams: {
    //     requestCulture: 'fa-IR'
    //   }
    // });

    localStorage.setItem('returnUrl', '/user/dashboard');

    this.oidcSecurityService.authorize(undefined, {
      customParams: {
        requestCulture: 'fa-IR',
      }
    });
    
  }

  logout() {
    this.oidcSecurityService.logoff().subscribe((res: any) => {
      console.log(res);
      this.modal.close();
    })
  }

  checkAuth(){

    // Check authentication status
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
      this.isAuthenticated = isAuthenticated;
      console.log('User is authenticated:', isAuthenticated);

        if (isAuthenticated) {
          this.router.navigate(['/user/dashboard']);
        } else {
          // Store the current route before authentication
          localStorage.setItem('returnUrl', '/user/dashboard');

          this.login()
      }
    });

    // this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated }) => {
    //   this.isAuthenticated = isAuthenticated;
    //   console.log('User is authenticated:', isAuthenticated);

    //   if (isAuthenticated) {
    //     this.router.navigate(['/user/dashboard']);
    //   } else {
    //     this.login()
    //   }
    // });

  }
}
